import React from "react";
import { gtm3Data } from "./data";
import "../assests/CSS/GTMComponent3.css";

const GTMComponent3 = () => {
  return (
    <div className="gtm3-container">
      <h2 className="gtm3-title">Smarter Qualification</h2>
      <p className="gtm3-subtitle">
        Make every connection count. Our form ensures that vendors and buyers meet
        with clarity and alignment from the start.
      </p>
      <div className="gtm3-card-wrapper">
        {gtm3Data.map((item, index) => (
          <div key={index} className="gtm3-card">
            <div className="gtm3-card-icon">
              <img src={item.icon} alt={item.title} />
            </div>
            <h3 className="gtm3-card-title">{item.title}</h3>
            <p className="gtm3-card-desc">{item.description}</p>
          </div>
        ))}
      </div>
      <button className="gtm3-btn">The BANT Form</button>
    </div>
  );
};

export default GTMComponent3;
